/**
 * Testimonials Schema
 * Schema-driven settings for customer testimonials section
 */
export default {
  id: 'testimonials',
  version: 1,
  title: 'Отзывы',
  description: 'Блок с отзывами клиентов',
  icon: 'MessageCircle',
  category: 'content',

  fields: [
    {
      group: 'Контент',
      fields: [
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Отзывы клиентов',
          defaults: { size: '3xl', weight: 'bold', color: 'foreground' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Подзаголовок',
          placeholder: 'Что говорят о нас',
          defaults: { size: 'lg', weight: 'normal', color: 'secondary' }
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'style',
          type: 'select',
          label: 'Стиль',
          mode: 'grid',
          columns: 2,
          options: [
            { value: 'cards', label: 'Карточки', icon: 'LayoutGrid' },
            { value: 'carousel', label: 'Карусель', icon: 'GalleryHorizontal' },
            { value: 'quotes', label: 'Цитаты', icon: 'Quote' },
            { value: 'minimal', label: 'Минимал', icon: 'Minus' }
          ]
        },
        {
          key: 'columns',
          type: 'select',
          label: 'Колонки (для карточек)',
          options: [
            { value: 1, label: '1' },
            { value: 2, label: '2' },
            { value: 3, label: '3' }
          ]
        }
      ]
    },
    {
      group: 'Отзывы',
      fields: [
        {
          key: 'testimonials',
          type: 'list',
          label: 'Отзывы',
          addLabel: 'Добавить',
          itemLabel: 'Отзыв',
          itemFields: [
            {
              key: 'name',
              type: 'input',
              label: 'Имя',
              placeholder: 'Имя клиента'
            },
            {
              key: 'position',
              type: 'input',
              label: 'Должность',
              placeholder: 'Должность'
            },
            {
              key: 'company',
              type: 'input',
              label: 'Компания',
              placeholder: 'Название компании'
            },
            {
              key: 'avatar',
              type: 'image',
              label: 'Фото'
            },
            {
              key: 'text',
              type: 'text',
              label: 'Текст отзыва',
              placeholder: 'Текст отзыва',
              multiline: true,
              rows: 3,
              defaults: { size: 'base', weight: 'normal', color: 'secondary' }
            },
            {
              key: 'rating',
              type: 'rating',
              label: 'Рейтинг',
              default: 5
            }
          ]
        }
      ]
    }
  ],

  default: {
    title: { text: 'Отзывы клиентов' },
    subtitle: { text: 'Что говорят о нас' },
    style: 'cards',
    columns: 2,
    testimonials: [
      {
        id: '1',
        name: 'Анна Петрова',
        position: 'Директор по маркетингу',
        company: 'ООО "Инновации"',
        avatar: 'https://placehold.co/150x150/1a1a2e/ffffff?text=AP',
        text: { text: 'Отличное место для проведения корпоративных мероприятий. Все необходимое оборудование, удобное расположение.' },
        rating: 5
      },
      {
        id: '2',
        name: 'Дмитрий Соколов',
        position: 'Основатель',
        company: 'Стартап "ТехноПро"',
        avatar: 'https://placehold.co/150x150/1a1a2e/ffffff?text=DS',
        text: { text: 'Проводили презентацию для инвесторов. Все прошло на высшем уровне. Рекомендую!' },
        rating: 5
      }
    ]
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      const migrated = { ...this.default, ...data };
      ['title', 'subtitle'].forEach(key => {
        if (typeof migrated[key] === 'string') {
          migrated[key] = { text: migrated[key] };
        }
      });
      if (migrated.testimonials) {
        migrated.testimonials = migrated.testimonials.map(item => ({
          ...item,
          id: item.id || Date.now().toString(),
          text: typeof item.text === 'string' ? { text: item.text } : (item.text || { text: '' })
        }));
      }
      return migrated;
    }
    return data;
  }
};
